module.exports = __webpack_public_path__ + "img/logotext.69e7eb88.svg";